let IslandsLogic = xClass("LslandsLogic")

let HomeSceneButton = require("clover/scene/component/homescene/HomeSceneButton")
let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager")

let instance = null
IslandsLogic.getInstance = function () {
    if (!instance) {
        instance = IslandsLogic.create()
    }
    return instance
}
IslandsLogic.prototype.ctor =function () {
    let self = this
}
IslandsLogic.prototype.isSupport = function () {
    return true
}
IslandsLogic.prototype.showIcon = function () {
    let self = this
    let icon = HomeSceneButton.create("我的岛屿", "homeScene/home_island.png", true, true, PromptTypeDef.justDot, true)
    icon.posIndex = 1
    icon.initRewardText()
    icon.rewardText.setSpriteFrame("homeScene/can_collect.png")
    icon.rewardText.setScale(0.92)
    icon.setRewardVisible(IslandsManager.getInstance().canGetIslandReward())
    icon.customInit = function () {
        let bgSize = this.bg.getContentSize()
        this.text.y = -bgSize.height / 2 * 0.8
        this.rewardText.y = this.text.y - this.text.getContentSize().height  * this.text.getScale() / 2 - this.rewardText.getContentSize().height / 2 * 0.8
    }
    icon.onCick = function () {
        self.showPanel()
        icon.setRewardVisible(false)
        // DCAssist.dc4ClickIcon("island", "click_icon")
    }
    self.icon = icon
    setTimeout(() => {
        // 此时 homeScene 还没有初始化完毕，直接getInstance  会导致递归调用
        let homeScene = require("clover/scene/HomeScene").getInstance()
        if (homeScene.btnLayer && !homeScene.btnLayer.IslandsBtn) {
            homeScene.btnLayer.IslandsBtn = icon
            homeScene.btnLayer.addBtnToSelf(icon, ICON_TYPE.kLeft)
        }
    }, 0);   
}
IslandsLogic.prototype.showPanel = function (callback) {
    // let self = this
    // let count = 2

    // if (self.isBusy) {
    //     callback && callback()
    //     return
    // }
    // self.isBusy = true
    // function success() {
    //     if (--count <= 0) {
    //         let scene = IslandsScene.create();
    //         cc.Director.getInstance().pushScene(scene);
    //         callback && callback()
    //         self.isBusy = false
    //     }
    // }

    // let IslandsScene = require("./IslandsScene");
    // IslandsScene.preloadWithPromise()
    //     .then(success)
    //     .catch(() => {
    //     // preloadWithLoading([], success, () => {
    //         Toast.make(getText("error.tip.load_res_error"), 1, () => {
    //             callback && callback()
    //             self.isBusy = false
    //         })
    //     });

    // IslandsManager.getInstance().loadFromServer(
    //     success, () => {
    //         callback && callback()
    //         self.isBusy = false
    //     }, () => {
    //         Toast.make(getText("error.tip.load_canceled"), 1, () => {
    //             callback && callback()
    //             self.isBusy = false
    //         })
    //     }
    // )
}
IslandsLogic.prototype.helpFriend = function (friendUid, islandId, isFromUrl, onSuccess, onFail, onCancel) {
    let self = this
    let http = HelpFriendsIslandHttp.new()
    http.addEventListener(Events.kComplete, () => {
        onSuccess && onSuccess()
    })
    http.addEventListener(Events.kError, () => {
        onFail && onFail()
    })
    http.addEventListener(Events.kCancel, () => {
        onCancel && onCancel()
    })
    http.load(friendUid, islandId, isFromUrl)
}
module.exports = IslandsLogic